export const UB_CONTACT = 'ubContact';
export const UB_CLIENT = 'ubClient';
export const UB_SERVICES = 'ubServices';
export const UB_AGENTS = 'ubAgents';
export const UB_BUSINESS_DEVELOPMENT = 'ubBusinessDevelopment';
export const UB_CONTENT = 'ubContent';
export const UB_INNOVATIONS = 'ubInnovations';
export const UB_OUTSIDE_DEPARTMENT = 'ubOutsideDepartment';
